/**
 * As opções de cidade dos mapas Mapbox viajam como `{ value: "UF-Cidade", label: … }`
 * (formato de `CidadesJSONController@getCidadesComUfByState`). Este parse é o único
 * ponto que conhece esse formato — as features compartilhadas o usam para falar com
 * as APIs, que esperam `cidade` e `estado` separados.
 *
 * @param {string} value Ex.: "PR-Curitiba".
 * @returns {{uf: string, cidade: string}|null}
 */
export function parseCidadeValue(value) {
    if (!value) return null;
    const idx = value.indexOf('-');
    if (idx === -1) return null;
    return { uf: value.slice(0, idx), cidade: value.slice(idx + 1) };
}
